




















import { computed, defineComponent, ref } from '@vue/composition-api';

import copyHandicraft from '@/gql/copyHandicraft.gql';
import copyCreator from '@/gql/copyCreator.gql';
import copyKnowledge from '@/gql/copyKnowledge.gql';
import copyLearningCenter from '@/gql/copyLearningCenter.gql';

import i18n from '@/i18n';
import { useMutation } from '@vue/apollo-composable';

const PanelWithCopyEntity = defineComponent({
  props: {
    type: {
      type: String,
      required: true,
    }, // handicraft, creator, learningCenter, knowledge,
    entity: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const copyHandicraftMutation = useMutation(copyHandicraft, () => ({ variables: { id: props.entity.id } }));
    const copyCreatorMutation = useMutation(copyCreator, () => ({ variables: { id: props.entity.id } }));
    const copyLearningCenterMutation = useMutation(copyLearningCenter, () => ({ variables: { id: props.entity.id } }));
    const copyKnowledgeMutation = useMutation(copyKnowledge, () => ({ variables: { id: props.entity.id } }));

    const computedMutation = computed(() => {
      if (props.type === 'handicraft') return copyHandicraftMutation;
      if (props.type === 'creator') return copyCreatorMutation;
      if (props.type === 'learningCenter') return copyLearningCenterMutation;
      if (props.type === 'knowledge') return copyKnowledgeMutation;
      return null;
    });

    const isCopying = ref(false);
    const copyResult = ref(null);

    async function onCopy() {
      if (computedMutation.value) {
        isCopying.value = true;
        try {
          const res = await computedMutation.value.mutate();
          copyResult.value = res.data[Object.keys(res.data)[0]];
        } catch (e) {
          copyResult.value = {
            success: false,
            message: e,
          } as any;
        }
      } else {
        console.error('Unexpected Error: computedMutation is null;');
      }
    }

    return {
      i18n,
      onCopy,
      computedMutation,
      copyResult,
      isCopying,
    };
  },
});

export default PanelWithCopyEntity;
